import React from "react";
import ResizableComponent from "../../Layouts/ResizableComponent";
import HeaderModes from "../../Layouts/Navbar/HeaderModes";
import Navbar from "../../Layouts/Navbar/Navbar";

const Schema = () => {
  return (
    <section className="main_section">
      <div className="sub_section">
        <div>
          <ResizableComponent
            resizeSide="right"
            storageKey="left_sidebar_size"
            defaultSize={193}
            range={[230, 400]} // Specify the range as [minSize, maxSize]
          >
            <HeaderModes />
            <div className="d_flex">
              <Navbar />

              <div className="d_flex w_100" style={{ backgroundColor: "var(--builder-bg)" }}></div>
            </div>
          </ResizableComponent>
        </div>

        <div className="d_flex justify_center w_100">
          <img src={require("../../images/sql.png")} style={{ objectFit: "cover" }} alt="schema" />
        </div>
      </div>
    </section>
  );
};

export default Schema;
